module.exports = __webpack_public_path__ + "img/pin-singulary.ec16faba.png";